
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      required: false,
      default: () => 'default',
    },
    align: {
      type: String,
      required: false,
      default: () => 'none',
    },
    useHeadline: {
      type: String,
      required: false,
      default: () => '0',
    },
    headlineAlign: {
      type: String,
      required: false,
      default: () => 'start',
    },
  },

  setup(props, context) {
    const colClass = computed<string[]>(() => {
      const colClasses = ['col-12 order-lg-1'];

      if (props.useHeadline === '1' && ['start', 'end'].indexOf(props.align) >= 0) {
        colClasses.push('col-lg-7 col-xl-8 col-xxl-9');
      } else if (props.width === 'default') {
        colClasses.push('col-md-10 col-lg-9');
      } else if (props.width === 'small') {
        colClasses.push('col-md-9 col-lg-7');
      } else if (props.width === 'wide') {
        colClasses.push('col-md-10');
      }

      return colClasses;
    });

    const textContent = context.slots.text ? context.slots.text() : null;
    const hasTextContent = computed(() => (
      textContent && textContent[0] ? `${textContent[0].children}`.trim().length > 0 : false
    ));

    return {
      colClass,
      hasTextContent,
    };
  },
});
